module.exports = __webpack_public_path__ + "img/williams.e4e3190c.png";